import { Box, styled, useTheme } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import SDatePicker from '@setvi/shared/components/sforms/sdate';
import { DateIconV2 } from '@setvi/shared/components/sicons';
import moment from 'moment';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  position: 'relative',
  padding: theme.spacing(1, 3)
}));

const DatePickerContainer = styled(Box)({
  width: '360px'
});

interface ExpirationDateStepProps {
  disabled?: boolean;
  helperText?: string;
  date: Date | null;
  error?: boolean;
  onChange: (date: Date) => void;
}

export const ExpirationDateStep = ({
  date,
  error,
  disabled,
  helperText,
  onChange
}: ExpirationDateStepProps) => {
  const { palette } = useTheme();
  const handleDateChange = (newDate: Date) => {
    onChange(newDate);
  };

  // Set minimum date to today (local time)
  const minDate = moment().startOf('day').toDate();

  // Set maximum date to 1 year from now
  const maxDate = moment().add(1, 'year').toDate();

  const iconProps = {
    fill: '#5D7083',
    stroke: '#afbac6a4'
  };

  return (
    <Container>
      <SText size="lg" weight="bold">
        Expiration Date{' '}
        <span style={{ color: palette.error.main, fontSize: 14 }}>*</span>
      </SText>

      <DatePickerContainer>
        <SDatePicker
          value={date}
          onChange={handleDateChange}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          hideCarret
          error={error}
          pickerLabel={
            <DateIconV2
              style={{
                width: 18,
                height: 18
              }}
              {...(disabled && iconProps)}
            />
          }
          placeholder="Select expiration date"
          format="MM/dd/yyyy"
          required
          placement="bottomStart"
        />
        {helperText && (
          <SText
            size="xs"
            noLineClamp
            fontColor={error ? '#FA2020' : '#AFBAC6'}
            title={helperText}
          />
        )}
      </DatePickerContainer>
    </Container>
  );
};
